import PropTypes from 'prop-types';
import { Navigate } from 'react-router-dom';
// hooks
import useAuth from '../hooks/useAuth';
// routes
import { PATH_DASHBOARD, PATH_ACCOUNT_OWNER, PATH_ADMIN } from '../routes/paths';
// components
import LoadingScreen from '../components/LoadingScreen';

// ----------------------------------------------------------------------

GuestGuard.propTypes = {
  children: PropTypes.node
};

export default function GuestGuard({ children }) {
  const { isAuthenticated, isInitialized, user } = useAuth();

  if (isAuthenticated && user.role === 'default') {
    return <Navigate to={PATH_DASHBOARD.root} />;
  }

  if(isAuthenticated && user.role === 'account_owner') {
    return <Navigate to={PATH_ACCOUNT_OWNER.root} />;
  }
  
  if(isAuthenticated && user.role === 'admin') {
    return <Navigate to={PATH_ADMIN.root} />;
  }

  if (!isInitialized) {
    return <LoadingScreen />;
  }
  
  return <>{children}</>;
}
